import PropTypes from 'prop-types';
var propTypes = {
  customStyle: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({})), PropTypes.shape({})]),
  disabled: PropTypes.bool,
  icon: PropTypes.element
};
export default propTypes;